import { store } from '@/store/'
import { parse, compareAsc } from 'date-fns'
const maxuploads = {
  getMessage(field, [args]) {
    // het maximale aantal bestanden is bereikt
    return store.getters.translation(14918) + ` (${args[0]})`
  },
  validate(value, [args]) {
    return value.length < Number(args[0])
  }
}

const minuploads = {
  getMessage(field, [args]) {
    // het maximale aantal bestanden is bereikt
    return store.getters.translation(14919) + `${args[0]}`
  },
  validate: (value, [args]) => {
    // console.log(value.filter(file => file.error === false).length >= Number(args[0]))
    if (value === null || value.length === 0) {
      return false
    }
    return value.filter(file => file.error === false).length >= Number(args[0])
  }
}

// const XDBDateCheck = {
//   getMessage(field, [args]) {
//     // het maximale aantal bestanden is bereikt
//     // store.getters.translation(14919) + `${args[0]}`
//     return 'Datum moet later zijn dan 01-01-1900.'
//   },
//   validate: (value, [args]) => {
//     return value >= new Date('1899-12-31')
//   }
// }
const XVFormatDate = {
  getMessage(field, [args]) {
    // het maximale aantal bestanden is bereikt
    // store.getters.translation(14919) + `${args[0]}`
    return 'Datum niet in juiste formaat'
  },
  validate: (value, [args]) => {
    let dateobj = parse(value, PEGLOBALS.Xdateformat, new Date())

    return dateobj instanceof Date && !isNaN(dateobj)
  }
}

const XVDateDefault = {
  getMessage(field, params, data) {
    return data.message
  },
  validate: (value, [args]) => {
    return new Promise(resolve => {
      resolve({
        valid: value instanceof Date && !isNaN(value) && value >= new Date('1899-12-31'),
        data: DateMessages(value)
      })
    })
  }
}
const XVDateAfter = {
  getMessage(value, { LabelBefore, LabelAfter }) {
    return `${LabelAfter} ${store.getters.translation(14377)} ${LabelBefore}`
  },
  validate: (value, { OtherDate }) => {
    return compareAsc(value, OtherDate) > 0
  },
  hasTarget: true
}

const XVDateAfterEqual = {
  getMessage(value, args) {
    return `${args[2]} ${store.getters.translation(15269)} ${args[1]}`
  },
  validate: (value, args) => {
    return compareAsc(value, args[0]) >= 0
  }
}
const XVDateBefore = {
  getMessage(value, args) {
    return `${args[2]} ${store.getters.translation(15270)} ${args[1]}`
  },
  validate: (value, args) => {
    return value < args[0]
  }
}
const XVDateBeforeEqual = {
  getMessage(value, args) {
    return `${args[2]} ${store.getters.translation(15271)} ${args[1]}`
  },
  validate: (value, args) => {
    return value <= args[0]
  }
}
function DateMessages(value) {
  if ((value instanceof Date && !isNaN(value)) === false) {
    return { message: store.getters.translation(5222) + ' ' + PEGLOBALS.Xdateformat.toLowerCase() }
  } else if (value <= new Date('1899-12-31')) {
    return { message: store.getters.translation(15266) }
  } else {
    return undefined
  }
}
const XVDateCheck = {
  getMessage(field, [args]) {
    // het maximale aantal bestanden is bereikt
    // store.getters.translation(14919) + `${args[0]}`
    return 'Datum moet later zijn dan 01-01-1900.'
  },
  validate: (value, [args]) => {
    let dateobj = parse(value, PEGLOBALS.Xdateformat, new Date())

    return dateobj >= new Date('1899-12-31')
  }
}

const IsRRNoValid = {
  getMessage(field) {
    // text in message
    return store.getters.translation(15031)
  },
  validate: value => {
    if (value == null) return false
    if (value.length !== 11) return false
    let leftPartS = value.substr(0, 9)
    let rightPartS = value.substr(9)

    let leftPartI = Number.parseInt(leftPartS)
    let rightPartI = Number.parseInt(rightPartS)

    // Special check for children of 21st century
    let thisyear = new Date().getUTCFullYear()
    let year = thisyear - 2000
    if (leftPartI < year * 10000000) {
      leftPartI += 2000000000
    }

    let mod = leftPartI % 97
    let compareTo = 97 - mod
    return compareTo === rightPartI

    // // RR numbers need to be 11 chars long
    // if (value.length !== 11) {
    //   return false
    // }

    // var checkDigit = value.substr(value.length - 2, 2)
    // var modFunction = function(nr) {
    //   return (97 - (nr % 97)).toString()
    // }

    // var nrToCheck = parseInt(value.substr(0, 9))

    // // first check without 2
    // if (modFunction(nrToCheck) === checkDigit) {
    //   return true
    // }

    // // then check with 2 appended for y2k+ births
    // nrToCheck = parseInt('2' + value.substr(0, 9))
    // console.log(modFunction(nrToCheck))
    // console.log(checkDigit)
    // return modFunction(nrToCheck) === checkDigit
  }
}
const XVMultipleEmail = {
  getMessage(value, args) {
    return store.getters.translation(5424)
  },
  validate: value => {
    let emailaddresses = value.split(';')
    let allgood = true

    emailaddresses.forEach(email => {
      const regex = /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/gm
      let m = regex.exec(email)
      if (m === null) {
        allgood = false
      }
    })

    return allgood
  }
}

const XVemail = {
  getMessage(value, args) {
    return store.getters.translation(16893)
  },
  validate: (value, args) => {
    let allgood = true
    const regex = /^([0-9a-zA-Z_]([-.&'`\w]*[0-9a-zA-Z_-])*@([0-9a-zA-Z][-&\w]*[0-9a-zA-Z]\.)+[a-zA-Z]{2,9})$/gm
    let m = regex.exec(value)
    if (m === null) {
      allgood = false
    }
    return allgood
  }
}
const XVvoorletters = {
  getMessage(value, args) {
    return store.getters.translation(16811)
  },
  validate: (value, args) => {
    let regex
    if (value.length > 1) {
      regex = /^([A-Z]\.)+$/gm
    } else {
      regex = /^([A-Z])+$/gm
    }
    let allgood = true

    let m = regex.exec(value)
    if (m === null) {
      allgood = false
    }
    return allgood
  }
}

const XVdecimal = {
  getMessage(value, { decimalCount }) {
    return store.getters.translation(3675) + decimalCount
  },
  validate: (value, { decimalCount }) => {
    if (isNaN(value.replace(',', '.'))) {
      return false
    }
    if (value !== '' && value !== null && value[value.length - 1] !== ',') {
      let stringValue = value.replace(',', '.').replace(' ', '')
      let indexofPoint = stringValue.indexOf('.')
      if (indexofPoint === -1) {
        return true
      }
      let countdec = stringValue.length - indexofPoint - 1

      if (countdec > decimalCount) {
        return false
      } else {
        let a = parseFloat(stringValue)

        // bepaal decimalen achter de comma
        if (!isFinite(a)) return 0
        let e = 1
        let p = 0
        while (Math.round(a * e) / e !== a) {
          e *= 10
          p++
        }

        return p <= decimalCount
      }
    } else {
      return false
    }
  }
}

export default {
  maxuploads,
  minuploads,
  IsRRNoValid,

  XVDateCheck,
  XVFormatDate,
  XVDateDefault,
  XVDateAfter,
  XVDateAfterEqual,
  XVDateBefore,
  XVDateBeforeEqual,
  XVMultipleEmail,
  XVdecimal,
  XVemail,
  XVvoorletters
}
